<template>
  <div>
    <h1 class="center margin-bottom">หนังสือรับรองพนักงาน</h1>
    <div class="tem-son-content margin-bottom">
      <div class="flex right line-feed">
        <div class="indent"></div>
        <div>หนังสือรับรองฉบับนี้ขอรับรองว่า</div>
        <div class="dotted"></div>
      </div>
      <div class="flex right line-feed">
        <div>เป็นพนักงานปฏิบัติหน้าที่ในต าแหน่ง</div>
        <div class="dotted"></div>
        <div>ฝ่าย</div>
        <div class="dotted"></div>
      </div>
      <div class="flex left line-feed">
        <div>บริษัท</div>
        <div class="dotted"></div>
        <div>โดยเริ่มงานตั้งแต่</div>
        <div style="width: 15%"></div>
      </div>

      <div class="flex left line-feed">
        <div>วันที่</div>
        <div class="dotted"></div>
        <div>เดือน</div>
        <div class="dotted"></div>
        <div>พ.ศ</div>
        <div class="dotted"></div>
        <div>เป็นต้นมาจนถึงปัจจุบัน</div>
        <div style="width: 20%"></div>
      </div>
    </div>

    <div class="flex margin-bottom">
      <div style="width: 20%"></div>
      <div>หนังสือรับรองฉบับนี้ขอรับรองว่า</div>
      <div class="dotted"></div>
      <div style="width: 30%"></div>
    </div>

    <div class="flex right tem-son-content">
      <div style="width: 60%"></div>
      <div>ลงชื่อ</div>
      <div class="dotted" style="flex: 1">
        <img style="width: 100%" :src="form.sign" alt="负责人签名" />
      </div>
      <div style="flex: 1; margin-left: 20px">
        <img style="width: 100%" :src="form.c_sign" alt="" />
      </div>
    </div>
    <div class="flex tem-son-content" style="margin-top: 20px">
      <div style="width: 60%"></div>
      <p>({{ form.staffName }})</p>
    </div>
    <div class="flex margin-bottom tem-son-content">
      <div style="width: 60%"></div>
      <p>
        {{ form.job }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    lang: {
      type: String,
      default: 'th'
    }
  }
}
</script>
